export default __webpack_public_path__ + "static/media/plus.ece68443.png";